module.exports = __webpack_public_path__ + "media/images/play-button-b50f2647a24de3959c399a9bb94a2645.png";